import { createContext, useState } from 'react';

export const ProfileDetailsContext = createContext();

const ProfileDetailsProvider = props => {
	const [createObj, setCreateObj] = useState({});
	const [originalObj, setOriginalObj] = useState({});

	return <ProfileDetailsContext.Provider value={{ createObj, originalObj, setCreateObj, setOriginalObj }}>{props.children}</ProfileDetailsContext.Provider>;
};

export default ProfileDetailsProvider;
